import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'templating', standalone: true })
export class TemplatingPipe implements PipeTransform {
  transform(template: string, data: object): string {
    if (!template) {
      return '';
    }

    let result = template;

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        result = result.replace(`{{${key}}}`, data[key] as string);
      }
    }

    return result;
  }
}
